import type {FetchWrapper} from '@/ts/api/fetch-wrapper';
import type {MetricEventDTO} from '@/ts/types/dto/metric-dto';

/** Sends analytics and tracking events to the metrics endpoint */
export class MetricApi {
  public constructor(private readonly fetch: FetchWrapper) {}

  public async logEvent(event: MetricEventDTO): Promise<void> {
    return this.fetch.post({
      url: '/metrics',
      body: event,
      emptyResponse: true,
    });
  }
}
